(function () {
  function initReveal() {
    if (typeof IntersectionObserver === 'undefined') {
      document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  }

  function initSticky() {
    var bar = document.getElementById('laev-stickybar');
    var trigger = document.querySelector('[data-hero-trigger]');
    if (!bar) return;
    var last = null;
    function update() {
      var show = trigger ? trigger.getBoundingClientRect().bottom < 64 : true;
      if (show !== last) {
        last = show;
        bar.style.transform = show ? 'translateY(0)' : 'translateY(-100%)';
        if (show) bar.classList.add('is-visible'); else bar.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initVideos() {
    document.querySelectorAll('video').forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.loop = true;
      v.setAttribute('muted', ''); v.setAttribute('loop', '');
      v.setAttribute('playsinline', ''); v.setAttribute('autoplay', '');
      var tryPlay = function () {
        try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      };
      v.addEventListener('canplay', tryPlay);
      if (typeof IntersectionObserver !== 'undefined') {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { tryPlay(); } else { try { v.pause(); } catch (e) {} }
          });
        }, { threshold: 0.15 }).observe(v);
      }
      tryPlay();
    });
  }

  window.laevSubscribe = function () {
    var inp = document.getElementById('laev-email');
    var form = document.getElementById('laev-email-form');
    var success = document.getElementById('laev-email-success');
    if (!inp || !inp.value || inp.value.indexOf('@') < 1) { if (inp) { inp.focus(); inp.style.borderColor = 'var(--cream)'; } return; }
    if (form) form.style.display = 'none';
    if (success) success.style.display = 'flex';
  };

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initSticky();
    initVideos();
  });
})();
